var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center my-5 min-vh-100"},[_c('span',{staticClass:"h1"},[_vm._v("Страница не найдена!")])])}]

export { render, staticRenderFns }